import { RefObject, useCallback, useEffect } from "react";

const useScrollToBottom = <T extends HTMLElement>(ref: RefObject<T>, delay: number, condition = true) => {
	const handleScrollToBottom = useCallback(() => {
		ref.current?.scrollIntoView({ block: "end", inline: "nearest", behavior: "smooth" });
	}, [ref]);

	useEffect(() => {
		if (!condition) return;
		setTimeout(handleScrollToBottom, delay);
	}, [delay, handleScrollToBottom, condition]);
};

export default useScrollToBottom;
